(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    const initializeAutoSubmitFilters = (root = document) => {
      root.querySelectorAll('[data-auto-submit-filters]').forEach((form) => {
        if (form.dataset.autoSubmitInitialized === 'true') return;

        form.dataset.autoSubmitInitialized = 'true';
        form.addEventListener('change', (event) => {
          if (!event.target.matches('input[type="checkbox"], input[type="number"]')) return;

          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        });
      });
    };

    const initializeFilterDisclosure = (root = document) => {
      root.querySelectorAll('[data-filter-expand]').forEach((button) => {
        if (button.dataset.filterInitialized === 'true') return;

        const list = document.getElementById(button.getAttribute('aria-controls'));
        const showMoreLabel = button.querySelector('[data-filter-show-more]');
        const showLessLabel = button.querySelector('[data-filter-show-less]');

        if (!list || !showMoreLabel || !showLessLabel) return;

        const collapsedOptions = list.querySelectorAll('[data-filter-option][hidden]');
        if (collapsedOptions.length === 0) {
          button.hidden = true;
          return;
        }

        button.dataset.filterInitialized = 'true';
        button.addEventListener('click', () => {
          const isExpanded = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', String(!isExpanded));
          showMoreLabel.hidden = !isExpanded;
          showLessLabel.hidden = isExpanded;

          collapsedOptions.forEach((option) => {
            option.hidden = isExpanded;
          });
        });
      });
    };

    const initializeFilterToggle = (root = document) => {
      root.querySelectorAll('[data-filter-toggle]').forEach((button) => {
        if (button.dataset.filterToggleInitialized === 'true') return;

        const panel = document.getElementById(button.getAttribute('aria-controls'));
        if (!panel) return;

        button.dataset.filterToggleInitialized = 'true';
        button.addEventListener('click', () => {
          const isOpen = panel.classList.toggle('is-open');
          button.setAttribute('aria-expanded', String(isOpen));
        });
      });
    };

    initializeAutoSubmitFilters();
    initializeFilterDisclosure();
    initializeFilterToggle();
    document.addEventListener('shopify:section:load', (event) => {
      initializeAutoSubmitFilters(event.target);
      initializeFilterDisclosure(event.target);
      initializeFilterToggle(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["events-index"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sortEventLists = (root = document) => {
      root.querySelectorAll('[data-events-index] [data-event-list]').forEach((list) => {
        const direction = list.dataset.sortDirection === 'descending' ? -1 : 1;
        const items = Array.from(list.querySelectorAll('[data-event-item]'));
        items
          .sort((first, second) => direction * (Number(first.dataset.eventStart) - Number(second.dataset.eventStart)))
          .forEach((item) => list.appendChild(item));
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => sortEventLists());
    } else {
      sortEventLists();
    }

    document.addEventListener('shopify:section:load', (event) => sortEventLists(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["live-schedule"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeLiveSchedules = () => {
      document.querySelectorAll("[data-oreilly-live-schedule]").forEach((section) => {
        if (section.dataset.liveScheduleInitialized === "true") return;
        section.dataset.liveScheduleInitialized = "true";

        const emptyState = section.querySelector("[data-live-schedule-empty]");
        const rows = Array.from(section.querySelectorAll("[data-live-schedule-event]"));
        const now = Math.floor(Date.now() / 1000);
        const visibleRows = rows
          .filter((row) => {
            const start = Number(row.dataset.start);
            const end = Number(row.dataset.end);
            const isLive = start <= now && end >= now;
            const isUpcoming = start >= now;
            const status = row.querySelector("[data-live-schedule-status]");
            row.hidden = !(isLive || isUpcoming);
            row.classList.toggle("is-live", isLive);
            if (status) {
              status.hidden = !isLive;
              status.textContent = isLive ? section.dataset.liveNowLabel : "";
            }
            return isLive || isUpcoming;
          })
          .sort((first, second) => Number(first.dataset.start) - Number(second.dataset.start));

        const eventItems = section.querySelector("[data-live-schedule-items]");
        if (eventItems) {
          eventItems.replaceChildren(...visibleRows.slice(0, 5));
          const remainingRows = visibleRows.slice(5);
          if (remainingRows.length) {
            const disclosure = document.createElement("details");
            disclosure.className = "oreilly-live-sale-list__disclosure";
            const summary = document.createElement("summary");
            summary.textContent = section.dataset.liveScheduleShowMoreLabel.replace("COUNT", String(remainingRows.length));
            const remainingList = document.createElement("div");
            remainingList.className = "oreilly-live-sale-list";
            remainingList.append(...remainingRows);
            disclosure.append(summary, remainingList);
            eventItems.append(disclosure);
          }
        }

        if (emptyState) emptyState.hidden = visibleRows.length > 0;

        const calendar = section.querySelector("[data-live-schedule-calendar]");
        const monthLabel = section.querySelector("[data-live-schedule-month]");
        const calendarGrid = section.querySelector("[data-live-schedule-calendar-grid]");
        const previousMonth = section.querySelector("[data-live-schedule-previous]");
        const nextMonth = section.querySelector("[data-live-schedule-next]");
        const eventDates = new Set(visibleRows.map((row) => row.dataset.date));
        const initialDate = visibleRows.length ? new Date(`${visibleRows[0].dataset.date}T12:00:00`) : new Date();
        let calendarDate = new Date(initialDate.getFullYear(), initialDate.getMonth(), 1);

        const renderCalendar = () => {
          if (!calendar || !monthLabel || !calendarGrid) return;
          const year = calendarDate.getFullYear();
          const month = calendarDate.getMonth();
          const firstWeekday = new Date(year, month, 1).getDay();
          const daysInMonth = new Date(year, month + 1, 0).getDate();
          monthLabel.textContent = calendarDate.toLocaleDateString(undefined, { month: "long", year: "numeric" });
          calendarGrid.replaceChildren();

          for (let index = 0; index < firstWeekday; index += 1) {
            const spacer = document.createElement("span");
            spacer.className = "is-empty";
            spacer.setAttribute("aria-hidden", "true");
            calendarGrid.appendChild(spacer);
          }

          for (let day = 1; day <= daysInMonth; day += 1) {
            const date = new Date(year, month, day);
            const dateKey = [
              date.getFullYear(),
              String(date.getMonth() + 1).padStart(2, "0"),
              String(date.getDate()).padStart(2, "0")
            ].join("-");
            const dayCell = document.createElement("span");
            dayCell.textContent = String(day);
            if (eventDates.has(dateKey)) {
              dayCell.classList.add("is-event-day");
              dayCell.setAttribute("aria-label", `Live event scheduled ${date.toLocaleDateString()}`);
            }
            calendarGrid.appendChild(dayCell);
          }
        };

        previousMonth?.addEventListener("click", () => {
          calendarDate = new Date(calendarDate.getFullYear(), calendarDate.getMonth() - 1, 1);
          renderCalendar();
        });
        nextMonth?.addEventListener("click", () => {
          calendarDate = new Date(calendarDate.getFullYear(), calendarDate.getMonth() + 1, 1);
          renderCalendar();
        });
        renderCalendar();

        const replayTrack = section.querySelector("[data-live-replay-track]");
        const replayPrevious = section.querySelector("[data-live-replay-previous]");
        const replayNext = section.querySelector("[data-live-replay-next]");

        if (replayTrack && replayPrevious && replayNext) {
          const updateReplayControls = () => {
            const maximumScroll = replayTrack.scrollWidth - replayTrack.clientWidth;
            replayPrevious.disabled = replayTrack.scrollLeft <= 1;
            replayNext.disabled = replayTrack.scrollLeft >= maximumScroll - 1;
          };
          const scrollReplays = (direction) => replayTrack.scrollBy({ left: direction * replayTrack.clientWidth, behavior: "smooth" });
          replayPrevious.addEventListener("click", () => scrollReplays(-1));
          replayNext.addEventListener("click", () => scrollReplays(1));
          replayTrack.addEventListener("scroll", updateReplayControls, { passive: true });
          window.addEventListener("resize", updateReplayControls);
          updateReplayControls();
        }
      });
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initializeLiveSchedules);
    } else {
      initializeLiveSchedules();
    }
    document.addEventListener("shopify:section:load", initializeLiveSchedules);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var product = window.__oreillyProduct;
    if (!product) return;

    var mainImg = document.getElementById('oreilly-main-img');
    var variantInput = document.getElementById('oreilly-variant-id');
    var priceEl = document.getElementById('oreilly-price');
    var atcBtn = document.getElementById('oreilly-atc');
    var paymentEl = document.querySelector('.oreilly-product__payment');
    var thumbs = document.querySelectorAll('.oreilly-product__thumb');
    var swatchRows = document.querySelectorAll('.oreilly-product__swatch-row');
    var imageSwapToken = 0;
    var preloadedImages = {};

    function normalizeImageSrc(src) {
      if (!src) return '';
      try {
        return new URL(src, window.location.href).href;
      } catch (e) {
        return src;
      }
    }

    function preloadImage(src) {
      var normalizedSrc = normalizeImageSrc(src);

      if (preloadedImages[normalizedSrc]) {
        return preloadedImages[normalizedSrc];
      }

      preloadedImages[normalizedSrc] = new Promise(function (resolve, reject) {
        var image = new Image();
        var settled = false;

        function resolveLoadedImage() {
          if (settled) return;
          settled = true;

          if (image.decode) {
            image.decode().catch(function () {}).then(function () {
              resolve(image);
            });
          } else {
            resolve(image);
          }
        }

        image.onload = resolveLoadedImage;
        image.onerror = function (error) {
          settled = true;
          delete preloadedImages[normalizedSrc];
          reject(error);
        };

        image.decoding = 'async';
        image.src = normalizedSrc;

        if (image.complete && image.naturalWidth > 0) {
          resolveLoadedImage();
        }
      });

      return preloadedImages[normalizedSrc];
    }

    function setActiveThumb(imageId) {
      thumbs.forEach(function (thumb) {
        thumb.classList.toggle('is-active', imageId && thumb.dataset.imageId === String(imageId));
      });
    }

    function swapMainImage(image) {
      if (!mainImg || !image || !image.src) return;

      var imageId = image.id ? String(image.id) : '';
      var targetSrc = normalizeImageSrc(image.src);
      var currentSrc = normalizeImageSrc(mainImg.currentSrc || mainImg.src);

      setActiveThumb(imageId);

      if ((imageId && mainImg.dataset.imageId === imageId) || currentSrc === targetSrc) {
        mainImg.alt = image.alt || '';
        if (imageId) mainImg.dataset.imageId = imageId;
        return;
      }

      var token = ++imageSwapToken;

      preloadImage(targetSrc).then(function () {
        if (token !== imageSwapToken) return;

        mainImg.src = targetSrc;
        mainImg.alt = image.alt || '';
        if (imageId) mainImg.dataset.imageId = imageId;
      }).catch(function () {
        if (token !== imageSwapToken) return;

        mainImg.src = targetSrc;
        mainImg.alt = image.alt || '';
        if (imageId) mainImg.dataset.imageId = imageId;
      });
    }

    // Thumbnail gallery
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        swapMainImage({
          src: thumb.dataset.src,
          alt: thumb.dataset.alt || '',
          id: thumb.dataset.imageId
        });
      });
    });

    function getSelectedOptions() {
      return Array.from(swatchRows).map(function (row) {
        var sel = row.querySelector('.oreilly-product__swatch.is-selected');
        return sel ? sel.dataset.value : null;
      });
    }

    function variantMatchesOptions(variant, options) {
      return options.every(function (opt, i) {
        return opt === null || variant['option' + (i + 1)] === opt;
      });
    }

    function findVariant(options) {
      return product.variants.find(function (variant) {
        return variantMatchesOptions(variant, options);
      });
    }

    function hasAvailableVariant(options) {
      return product.variants.some(function (variant) {
        return variant.available && variantMatchesOptions(variant, options);
      });
    }

    function updateOptionAvailability(selectedOptions) {
      swatchRows.forEach(function (row) {
        var optionIndex = parseInt(row.dataset.optionIndex, 10);

        row.querySelectorAll('.oreilly-product__swatch').forEach(function (swatch) {
          var testOptions = selectedOptions.slice();
          testOptions[optionIndex] = swatch.dataset.value;

          var isAvailable = hasAvailableVariant(testOptions);
          var isSelected = swatch.classList.contains('is-selected');
          swatch.classList.toggle('is-unavailable', !isAvailable);
          swatch.disabled = !isAvailable && !isSelected;
          swatch.setAttribute('aria-disabled', String(!isAvailable));

          if (isAvailable) {
            swatch.removeAttribute('title');
            swatch.setAttribute('aria-label', swatch.dataset.value);
          } else {
            swatch.setAttribute('title', 'Sold out for selected options');
            swatch.setAttribute('aria-label', swatch.dataset.value + ' - sold out for selected options');
          }
        });
      });
    }

    function syncSelectedVariant(options) {
      var variant = findVariant(options);

      if (variant) {
        if (variantInput) variantInput.value = variant.id;
        updatePrice(variant);
        updateAtc(variant);

        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());

        if (variant.featured_image) {
          var matchThumb = document.querySelector('[data-image-id="' + variant.featured_image.id + '"]');
          swapMainImage({
            src: matchThumb ? matchThumb.dataset.src : variant.featured_image.src,
            alt: matchThumb ? matchThumb.dataset.alt : (variant.featured_image.alt || product.title),
            id: variant.featured_image.id
          });
        }
      } else {
        if (variantInput) variantInput.value = '';
        updatePrice(null);
        updateAtc(null);

        var nextUrl = new URL(window.location.href);
        nextUrl.searchParams.delete('variant');
        window.history.replaceState({}, '', nextUrl.toString());
      }

      updateOptionAvailability(options);
    }

    function handleOptionClick(row, swatch) {
      if (swatch.disabled) return;

      row.querySelectorAll('.oreilly-product__swatch').forEach(function (s) {
        s.classList.remove('is-selected');
        s.setAttribute('aria-pressed', 'false');
      });

      swatch.classList.add('is-selected');
      swatch.setAttribute('aria-pressed', 'true');

      var optIndex = parseInt(row.dataset.optionIndex, 10);
      var optValEl = document.getElementById('oreilly-opt-val-' + (optIndex + 1));
      if (optValEl) optValEl.textContent = swatch.dataset.value;

      var options = getSelectedOptions();

      syncSelectedVariant(options);
    }

    function formatMoney(cents) {
      var dollars = (cents / 100).toFixed(2);
      return '$' + dollars.replace(/\.00$/, '');
    }

    function updatePrice(variant) {
      if (!variant) {
        if (priceEl) priceEl.innerHTML = '<span class="oreilly-product__current-price">Unavailable</span>';
        return;
      }

      var html = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html += '<s class="oreilly-product__compare">' + formatMoney(variant.compare_at_price) + '</s>';
      }
      html += '<span class="oreilly-product__current-price">' + formatMoney(variant.price) + '</span>';
      if (priceEl) priceEl.innerHTML = html;
    }

    function updateAtc(variant) {
      if (!atcBtn) return;
      if (variant && variant.available) {
        atcBtn.disabled = false;
        atcBtn.textContent = 'Add to Cart';
        if (paymentEl) paymentEl.hidden = false;
      } else {
        atcBtn.disabled = true;
        atcBtn.textContent = variant ? 'Sold Out' : 'Unavailable';
        if (paymentEl) paymentEl.hidden = true;
      }
    }

    // Swatch selection
    swatchRows.forEach(function (row) {
      row.querySelectorAll('.oreilly-product__swatch').forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          handleOptionClick(row, swatch);
        });
      });
    });

    syncSelectedVariant(getSelectedOptions());

    // Quantity stepper
    var qtyInput = document.getElementById('oreilly-qty');
    var qtyMinus = document.getElementById('oreilly-qty-minus');
    var qtyPlus = document.getElementById('oreilly-qty-plus');

    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        if (v > 1) qtyInput.value = v - 1;
      });
    }

    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = v + 1;
      });
    }

    // AJAX add-to-cart: keep the shopper on the PDP instead of a hard redirect to /cart
    var routes = window.__oreillyRoutes || {};
    var form = document.getElementById('oreilly-product-form');

    function updateCartCount() {
      fetch((routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (cartData) {
          var cartLink = document.querySelector('.oreilly-header__icons a[aria-label="Cart"]');
          if (!cartLink) return;

          var sup = cartLink.querySelector('sup');
          if (cartData.item_count > 0) {
            if (!sup) {
              sup = document.createElement('sup');
              cartLink.insertBefore(sup, cartLink.firstChild);
            }
            sup.textContent = cartData.item_count;
          } else if (sup) {
            sup.remove();
          }
        })
        .catch(function () {});
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (atcBtn && atcBtn.disabled) return;

        var originalLabel = atcBtn ? atcBtn.textContent : '';
        if (atcBtn) {
          atcBtn.disabled = true;
          atcBtn.textContent = 'Adding…';
        }

        fetch(routes.cartAdd || '/cart/add', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (response) {
            if (!response.ok) return response.json().then(function (err) { throw err; });
            return response.json();
          })
          .then(function () {
            updateCartCount();
            if (atcBtn) atcBtn.textContent = 'Added ✓';
            setTimeout(function () {
              if (!atcBtn) return;
              atcBtn.disabled = false;
              atcBtn.textContent = originalLabel;
            }, 1600);
          })
          .catch(function () {
            if (atcBtn) {
              atcBtn.disabled = false;
              atcBtn.textContent = originalLabel;
            }
            window.location.href = routes.cart || '/cart';
          });
      });
    }

    var recommendations = document.querySelector('[data-product-recommendations]');
    if (recommendations && recommendations.dataset.url) {
      fetch(recommendations.dataset.url)
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to load recommendations');
          return response.text();
        })
        .then(function (html) {
          var documentFragment = new DOMParser().parseFromString(html, 'text/html');
          var renderedRecommendations = documentFragment.querySelector('[data-product-recommendations]');

          if (!renderedRecommendations || !renderedRecommendations.innerHTML.trim()) return;

          recommendations.innerHTML = renderedRecommendations.innerHTML;
          recommendations.hidden = false;
        })
        .catch(function () {});
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upcoming-events"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeSchedules = () => {
      document.querySelectorAll("[data-oreilly-event-schedule]").forEach((schedule) => {
        if (schedule.dataset.oreillyScheduleInitialized === "true") {
          return;
        }

        const list = schedule.querySelector("[data-oreilly-event-list]");
        const emptyState = schedule.querySelector("[data-oreilly-event-empty]");
        const rows = Array.from(schedule.querySelectorAll("[data-oreilly-schedule-item]"));

        if (!list || !emptyState) {
          return;
        }

        schedule.dataset.oreillyScheduleInitialized = "true";

        const now = Math.floor(Date.now() / 1000);
        const days = Number(schedule.dataset.days) || 7;
        const scheduleEnd = now + (days * 24 * 60 * 60);
        let visibleCount = 0;

        rows
          .sort((first, second) => Number(first.dataset.start) - Number(second.dataset.start))
          .forEach((row) => {
            const start = Number(row.dataset.start);
            const end = Number(row.dataset.end);
            const isLive = start <= now && end >= now;
            const isUpcoming = start >= now && start <= scheduleEnd;
            const isVisible = isLive || isUpcoming;
            const status = row.querySelector("[data-oreilly-event-status]");
            const statusContainer = row.querySelector("[data-oreilly-event-status-container]");

            row.hidden = !isVisible;
            row.classList.toggle("is-live", isLive);

            if (status) {
              status.hidden = !isLive;
              status.textContent = isLive ? schedule.dataset.liveNowLabel : "";
            }

            if (statusContainer) {
              statusContainer.hidden = !isLive;
            }

            if (isVisible) {
              list.appendChild(row);
              visibleCount += 1;
            }
          });

        emptyState.hidden = visibleCount > 0;
      });
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initializeSchedules);
    } else {
      initializeSchedules();
    }

    document.addEventListener("shopify:section:load", initializeSchedules);
  })();

  } catch(e) { console.error(e); }
})();
})();
